<template>
  <Modal
    :showModal="showModal"
    @close="$emit('close')"
    class="modal-inventory"
  >
    <template v-slot:header>
      <div class="modal-inventory__title-wrap">
        {{ $t('cart.inventory.notice') }}
      </div>
    </template>
    <template v-slot:body v-if="inventoryData">
      <template v-if="inventoryData.isClearance">
        <p v-if="inventoryData.inventoryQty === 0" class="modal-inventory__message" >
          <i18n path="cart.inventory.clearenceOutOfStock">
            <strong v-html="inventoryData.productTitle"></strong>
          </i18n>
        </p>
        <p v-else class="modal-inventory__message">
          <i18n path="cart.inventory.clearenceLowStock">
            <strong v-html="inventoryData.productTitle"></strong>
            <strong>{{ inventoryData.inventoryQty }}</strong>
            <strong v-html="inventoryData.productTitle"></strong>
          </i18n>
        </p>
      </template>

      <p v-else class="modal-inventory__message">
        <i18n path="cart.inventory.lowInventory">
          <strong v-html="inventoryData.productTitle"></strong>
        </i18n>
      </p>
    </template>
    <template v-slot:footer>
      <div class="modal__actions">
        <button
          type="button"
          class="button button--primary"
          @click="$emit('close')"
        >
          {{ $t('common.ok') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/modal/Modal'

export default {
  name: 'ModalInventory',
  components: {
    Modal
  },
  props: ['inventoryData', 'showModal']
}
</script>
